module.exports = __webpack_public_path__ + "img/Vector (1).b5ad406c.svg";